const areasData = {
  "near-me": {
    name: "Near Me",
    state: "PA",
    slug: "near-me",
    distance: "Local",
    driveTime: "Under 30 minutes from most areas",
    metaTitle: "Phone Repair Near Me | Same-Day Service | Cell Station Willow Grove, PA",
    metaDescription:
      "Phone repair near you in the Willow Grove / Philadelphia suburbs area. Same-day iPhone, Samsung, iPad & laptop repair. 19+ years experience. Call (215) 939-3933.",
    description:
      "Searching for phone repair near me? Cell Station in Willow Grove, PA is your local expert — serving Montgomery County, Bucks County, and North Philadelphia. We're typically under 30 minutes from wherever you are. Whether you're in Willow Grove, Horsham, Abington, Hatboro, Warminster, Glenside, Jenkintown, or Philadelphia itself, we've served your neighbors since 2006. Same-day iPhone, Samsung, iPad, and laptop repair with a 30-day warranty on every job.",
    landmarks:
      "Centrally located at 2500 W Moreland Rd — easy access from PA Turnpike, Route 611, Route 263, and Easton Road.",
  },
  philadelphia: {
    name: "Philadelphia",
    state: "PA",
    slug: "philadelphia",
    distance: "14 miles",
    driveTime: "25 minutes",
    metaTitle: "Screen & Phone Repair Near Philadelphia, PA | Cell Station",
    metaDescription:
      "Looking for phone or screen repair near Philadelphia? Cell Station in Willow Grove is just 25 minutes north. iPhone, Samsung, iPad, MacBook repairs. Call (215) 939-3933.",
    description:
      "Philadelphia residents — Cell Station is just 14 miles north of downtown Philly in Willow Grove, about a 25-minute drive up Broad Street or I-95. Whether you're in Center City, Northeast Philly, Fishtown, or Mount Airy, we're a quick trip for expert iPhone, Samsung, iPad, and MacBook repair. We're often faster and more affordable than Philadelphia shops — and every repair includes a 30-day warranty.",
    landmarks:
      "From Philadelphia, take I-276/PA Turnpike or Broad Street/Route 611 north — we're near Willow Grove Park Mall.",
  },
  horsham: {
    name: "Horsham",
    state: "PA",
    slug: "horsham",
    distance: "4 miles",
    driveTime: "10 minutes",
    metaTitle: "Cell Phone Repair Near Horsham, PA | Cell Station",
    metaDescription:
      "Looking for phone repair near Horsham, PA? Cell Station in Willow Grove is just 10 minutes away. iPhone, Samsung, iPad & laptop repair. Call (215) 939-3933.",
    description:
      "Cell Station is conveniently located just 4 miles from Horsham, PA — about a 10-minute drive. Whether you're coming from Horsham Township, the Shops at Horsham, or anywhere along Route 611, we're easy to find at the Willow Grove Park Mall area. Horsham residents trust Cell Station for fast, affordable repairs with same-day service on most devices.",
    landmarks:
      "Just a quick drive down Easton Road or Route 611 from Horsham Township.",
  },
  abington: {
    name: "Abington",
    state: "PA",
    slug: "abington",
    distance: "6 miles",
    driveTime: "15 minutes",
    metaTitle: "Cell Phone Repair Near Abington, PA | Cell Station",
    metaDescription:
      "Need phone repair near Abington, PA? Cell Station in Willow Grove is just 15 minutes away. Expert repair for all devices. Call (215) 939-3933.",
    description:
      "Abington residents — Cell Station is just 6 miles away in Willow Grove, about a 15-minute drive. Whether you're near Abington Hospital, Old York Road, or the Abington School District area, you're close to expert device repair. We've been the go-to repair shop for Abington customers for over 19 years.",
    landmarks:
      "A short trip down Old York Road or Route 611 from Abington Township.",
  },
  hatboro: {
    name: "Hatboro",
    state: "PA",
    slug: "hatboro",
    distance: "3 miles",
    driveTime: "8 minutes",
    metaTitle: "Cell Phone Repair Near Hatboro, PA | Cell Station",
    metaDescription:
      "Fast phone repair near Hatboro, PA. Cell Station is just 8 minutes away in Willow Grove. Same-day service. Call (215) 939-3933.",
    description:
      "Hatboro is one of our closest neighbors — just 3 miles and about an 8-minute drive to Cell Station. If you're on York Road in downtown Hatboro, we're a straight shot south on Route 263. Many Hatboro families and businesses rely on us for quick, reliable phone and computer repairs.",
    landmarks:
      "Head south on York Road from downtown Hatboro — we're right near Willow Grove Park Mall.",
  },
  warminster: {
    name: "Warminster",
    state: "PA",
    slug: "warminster",
    distance: "5 miles",
    driveTime: "12 minutes",
    metaTitle: "Cell Phone Repair Near Warminster, PA | Cell Station",
    metaDescription:
      "Phone repair near Warminster, PA. Cell Station is just 12 minutes away. iPhone, Samsung, iPad & computer repair. Call (215) 939-3933.",
    description:
      "Warminster residents are just 5 miles from Cell Station in Willow Grove — about a 12-minute drive. Whether you're near the Warminster SEPTA station, Ann's Choice, or along Street Road, getting to us is easy. We offer the same-day repair service that Warminster customers have trusted for nearly two decades.",
    landmarks:
      "Take Street Road or Route 263 south from Warminster to reach us quickly.",
  },
  glenside: {
    name: "Glenside",
    state: "PA",
    slug: "glenside",
    distance: "8 miles",
    driveTime: "18 minutes",
    metaTitle: "Cell Phone Repair Near Glenside, PA | Cell Station",
    metaDescription:
      "Looking for phone repair near Glenside, PA? Cell Station in Willow Grove is 18 minutes away. Expert repairs, same-day service. Call (215) 939-3933.",
    description:
      "Glenside and Cheltenham residents — Cell Station is about 8 miles north in Willow Grove, roughly an 18-minute drive up Route 611 or the Turnpike. Whether you're near Arcadia University, Keswick Village, or South Easton Road, we're worth the short trip for quality repairs at fair prices with a warranty included.",
    landmarks:
      "Take Easton Road or Route 611 north from Glenside — easy highway access via the PA Turnpike.",
  },
  jenkintown: {
    name: "Jenkintown",
    state: "PA",
    slug: "jenkintown",
    distance: "7 miles",
    driveTime: "16 minutes",
    metaTitle: "Cell Phone Repair Near Jenkintown, PA | Cell Station",
    metaDescription:
      "Phone repair near Jenkintown, PA. Cell Station in Willow Grove is just 16 minutes away. All devices repaired. Call (215) 939-3933.",
    description:
      "Jenkintown is just 7 miles from Cell Station — about a 16-minute drive up Old York Road. Whether you're near the Jenkintown SEPTA station, Jenkintown Town Square, or Hiway Theater, we're a quick trip north. Jenkintown customers love our transparent pricing, fast turnaround, and 30-day warranty on all repairs.",
    landmarks:
      "A straight shot up Old York Road from Jenkintown Borough to our Willow Grove location.",
  },
};

export default areasData;
